import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const SHOW_MS = 10000;
const EVENT_END = new Date("2026-10-17T23:59:59-04:00");
const KEY = "sfr-walk-flyer-seen";

export default function FlyerPopup() {
  const [open, setOpen] = useState(() => new Date() <= EVENT_END && !sessionStorage.getItem(KEY));

  useEffect(() => {
    if (!open) { return; }
    sessionStorage.setItem(KEY, "1");
    const t = setTimeout(() => setOpen(false), SHOW_MS);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-[1000] flex items-center justify-center bg-[#03045E]/70 backdrop-blur-sm p-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setOpen(false)} data-testid="walk-flyer-popup">
          <motion.div className="relative w-full max-w-[400px]" initial={{ scale: 0.85, y: 30 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, opacity: 0 }} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setOpen(false)} aria-label="Close flyer" data-testid="walk-flyer-close" className="absolute -top-3 -right-3 z-10 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center text-[#03045E] hover:bg-sky-50">
              <X className="w-5 h-5" />
            </button>
            <Link to="/events#walk" onClick={() => setOpen(false)} data-testid="walk-flyer-link">
              <img src="/brand/walk-flyer.webp" alt="Swim for Rakim 2nd Annual Walk — Saturday, October 17, 2026, 8 AM, Friendship Fountain, 1015 Museum Cir, Jacksonville, FL 32207. Walk starts at 8:15 sharp." className="w-full max-h-[82vh] object-contain rounded-2xl shadow-2xl" />
            </Link>
            <div className="mt-3 h-1.5 rounded-full bg-white/30 overflow-hidden">
              <motion.div className="h-full bg-[#FF6B35]" initial={{ width: "100%" }} animate={{ width: "0%" }} transition={{ duration: SHOW_MS / 1000, ease: "linear" }} />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
